import remoteJs from './modules/remote-js'
import vorlonJs from './modules/vorlon-js'
const consoleJs = () => {
  remoteJs()
  vorlonJs()
}
export default consoleJs
